import gql from "graphql-tag";

export const couponFragment = gql`
  fragment CouponFragment on Coupon {
    id
    code
    name
    dealType
    category
    eventLocation
    eventStartDate
    eventEndDate
    isHidden
    isFeatured
    isExclusiveRedemption
    isNationwide
    quantity
    assignee
    currency
    redeemType
    usageLimit
    userType
    usageTimerHour
    usageTimerMinute
    usageTimerSecond
    isUsageTimerApplied
    mainPromoTitle
    mainPromoDescription
    mechanics
    accessPageSubtitle
    accessPageTagline
    accessPageDescription
    malls(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          id
          name
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
    promoImage {
      url
      alt
    }
    accessImage {
      url
      alt
    }
    discountValue
    startDate
    endDate
    redeemStartDate
    redeemEndDate
    occurence
    occurenceExclude
    redemptionFrequency
    redemptionExclude
    deeplinkUrl
    shortDynamicLink
  }
`;
